export enum FSVersionEnum {
  FS10 = 'FS1.0',
  FS20 = 'FS2.0',
}
